// extracted by mini-css-extract-plugin
export default {"mainContainer":"admin-menu_mainContainer__pf2v9","gridWrapper":"admin-menu_gridWrapper__0KWtl","sideMenu":"admin-menu_sideMenu__hlCmb","rightPanel":"admin-menu_rightPanel__pV+ju"};